module.exports = fox._r("images/gallery-sprite.png", __webpack_public_path__ + "_/_/_/root/images/gallery-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/gallery-sprite.png
// module id = 29
// module chunks = 4